// Spec: specs/stats/questions/data_lab/storytelling_notes/functional_requirements.md §Draft lifecycle

import type { Draft } from '@aytm/app/stats/page/question-views/components/lib/drafts/draftStore'

type Asset = Record<string, unknown> | null | undefined

export interface DraftFields {
  text?: string | null
  note?: string | null
  asset?: Asset
  imageSlide?: boolean | null
}

// the trimming SAVE applies, so the saved item and a draft compare alike
export const trimNote = (html?: string | null): string =>
  (html || '').replace(/^(?:\s*<br\b[^>]*>\s*)+|(?:\s*<br\b[^>]*>\s*)+$/gi, '').trim()

export const illustration = (asset: Asset): Record<string, unknown> | null =>
  asset && Object.prototype.hasOwnProperty.call(asset, 'path') ? asset : null

// by uid: a resumed draft holds a copy of the asset, or null where the saved note holds {}
export const illustrationUid = (asset: Asset): unknown => illustration(asset)?.uid ?? null

// the typed state and the saved item go through here alike, so the two compare field by field
export const toDraft = ({ text, note, asset, imageSlide }: DraftFields): Draft => ({
  text: text || '',
  note: trimNote(note),
  asset: illustration(asset),
  imageSlide: Boolean(imageSlide)
})

export const draftsMatch = (a: Draft, b: Draft): boolean =>
  a.text === b.text &&
  a.note === b.note &&
  illustrationUid(a.asset) === illustrationUid(b.asset) &&
  a.imageSlide === b.imageSlide
